import siteService from "@services/siteService.js";
import googleService from "@services/googleService.js";
import embedCodeService from "@services/embedCodeService.js";
import fileService from "@services/fileService.js";
import * as jsonpatch from 'fast-json-patch';

const state = {
  config: {
    currencies: {}
  },
  pages: {},
  pageName: '',
  services: {},
  screen: {
    languages: {},
    domain: {},
    product: {},
    post: {},
    blog: {},
    album: {},
    albumCategory: {},
    eventCalendar: {},
  },
  publishStatus: {
    status: "published"
  },
  isExamplePage: false,
  currencyMain: undefined,
  currencyUse: undefined,
  currencyDisplay: undefined,
  currenciesConverter: [],
  multiplier: 1,
  limit: {
    section: null,
    slideSection: null, // ------ Include in section ------ Ex: section limit: 5, slide section limit: 1 MEAN: other section 4 + slide section 1 = 5 section
    grid: null,
    slidePage: null,
    packageID: 6,
  },
  productReviewConfig: {},
}

const getters = {

  pages: state => {
    return state.pages;
  },
  pageName: state => {
    return state.pageName;
  },
  services: state => {
    return state.services
  },

  publishStatus: state => {
    return state.publishStatus
  },
  languages: state => {
    return state.screen.languages
  },
  domain: state => {
    return state.screen.domain
  },
  product: state => {
    return state.screen.product
  },
  blog: state => {
    return state.screen.blog
  },
  post: state => {
    return state.screen.post
  },
  album: state => {
    return state.screen.album
  },
  albumCategory: state => {
    return state.screen.albumCategory
  },
  eventCalendar: state => {
    return state.screen.eventCalendar
  },
  sections: state => {
    return state.screen.sections;
  },
  isExamplePage: state => {
    return state.isExamplePage;
  },
  currencies: state => {
    return state.config.currencies;
  },
  currencyMain: state => {
    return state.currencyMain
  },
  currencyUse: state => {
    return state.currencyUse
  },
  currencyDisplay: state => {
    return state.currencyDisplay
  },
  currenciesConverter: state => {
    return state.currenciesConverter
  },
  isEnableAutoConverter: state => {
    return state.config.currencies.isEnableAutoConverter
  },
  multiplier: state => {
    return state.multiplier
  },
  limit: state => {
    return state.limit;
  },
  productReviewConfig: state => {
    return state.productReviewConfig;
  },
}
const actions = {
  initialiseDesignIFrame({ commit, dispatch }, { iframeWin }) {
    dispatch('initGoogleMap')
    dispatch('initEmbedCode')
    commit("design/setIframe", { iframeWin }, { root: true });
    window.onmessage = (e) => dispatch("design/childMsg", e, { root: true })
  },
  // Publish
  fetchPublishStatus({ commit, dispatch }, { useModal }) {
    siteService.publishStatus().then((publishStatus) => {
      commit('setPublishStatus', { publishStatus })
      if (publishStatus.status == 'processing') { // processing
        setTimeout(() => dispatch('fetchPublishStatus'), 1000)
      } else { // published
        dispatch('design/unblockloading', {}, { root: true });
        if (useModal) {
          dispatch('design/setModal', { name: 'modal-publish' }, { root: true })
        }
      }
    }).catch(() => {

    })
  },
  async publishWebsite({ dispatch }) {
    // Check Reload RenderVersion
    const reload = await dispatch('design/checkReloadByRenderVersion', {}, { root: true });
    if (reload) return;
    
    // Publish
    dispatch('design/blockloading', {}, { root: true });
    siteService.publishSite().then(() => {
      dispatch('fetchPublishStatus', { useModal: true });
    }).catch(() => {
      dispatch('fetchPublishStatus', { useModal: true });
    })
  },
  initSiteConfig({ commit, dispatch }, { languages, currencies, services, domain, product, post, blog, album, albumCategory, eventCalendar, productReviewConfig, statVisitorCount}) {
    commit('SET_SITE_SERVICES', { services })
    commit('SET_LANGUAGES', { languages })
    commit('SET_DOMAIN', { domain })
    commit('SET_PRODUCT', { product })
    commit('SET_BLOG', { blog })
    commit('SET_POST', { post })
    commit('SET_ALBUM', { album })
    commit('SET_ALBUM_CATEGORY', { albumCategory })
    commit('SET_EVENT_CALENDAR', { eventCalendar })
    commit('SET_PRODUCT_REVIEW_CONFIG', { productReviewConfig })
    dispatch('initImagesID')
    dispatch('initCurrency', { currencies })
    dispatch('initStatVisitorCount', { statVisitorCount })
  },
  initMainMetadata({ commit }, { props, assets }) {
    commit('design/metadata/SET_MATADATA_MAIN', { props, assets }, { root: true })
  },
  async initGoogleMap({ commit,rootState }, ) {
    if(rootState.design.snapshot.metadataObserver && rootState.design.metadata) {
      jsonpatch.unobserve(rootState.design.metadata, rootState.design.snapshot.metadataObserver)
    }
    const gmap = await googleService.getGoogleMap();
    const key = gmap.googleMapKey && gmap.isOpenMap ? gmap.googleMapKey : process.env.VUE_APP_EDITOR_SETTING_GOOGLE_MAP_KEY
    let gmapObj = Object.keys(gmap).length > 0 ? gmap : {
      mapKeyID: "default",
      googleMapKey: process.env.VUE_APP_EDITOR_RENDER_GOOGLE_MAP_KEY,
      isOpenMap: true
    }
    commit('design/metadata/SET_GOOGLEMAP', { key, gmapObj }, { root: true })
    if(rootState.design.snapshot.metadataObserver &&  rootState.design.metadata) {
      rootState.design.snapshot.metadataObserver = jsonpatch.observe(rootState.design.metadata);
    }
  },
  async initEmbedCode({ commit } ) {
    const embedCode = await embedCodeService.getEmbedCodes();
    commit('design/metadata/SET_EMBEDCODE', { embedCode }, { root: true })
  },
  async initImagesID({ commit, dispatch } ) {
    const imagesID = await fileService.getImagesID();
    commit('design/siteData/SET_IMAGES_ID', { imagesID }, { root: true })
    dispatch("design/postToChildren", {
      func: "page/setImagesID",
      payload: { imagesID },
    }, { root: true });
  },
  async initCurrency({ commit, dispatch }, { currencies }) {
    const currencyMain = currencies.data.find((item) => item.isMain).code;
    const currencyUse =currencies.data.find((item) => item.isMain).code;
    const currenciesConverter = currencies.data.reduce(
        (obj, item) => ({
          ...obj,
          [item.code]: item,
        }),
        {}
      );

    commit('SET_CURRENCY_CONFIG', currencies)
    commit('SET_CURRENCY_MAIN', currencyMain );
    commit('SET_CURRENCY_USE', currencyUse );
    commit('SET_CURRENCIES_CONVERTER', currenciesConverter );

    dispatch('setMultiplier');
    dispatch('setCurrencyDisplay');
  },
  setCurrencyDisplay({ commit, state }) {
    const currencyDisplayType = state.config.currencies.currencyDisplay;

    let currencyDisplay = undefined;
    if (currencyDisplayType === 'symbol') {
      currencyDisplay = state.currenciesConverter[state.currencyUse].symbol;
    } else {
      currencyDisplay = state.currenciesConverter[state.currencyUse].code;
    }

    commit('SET_CURRENCY_DISPLAY', currencyDisplay );
  },
  setMultiplier: async ({ commit, state })  => {
    const multiplier = state.currenciesConverter[state.currencyUse].multiplier;
    commit('SET_MULTIPLIER', multiplier );
  },

  // saveGoogleMap({ dispatch }, gmap) {

  //   dispatch("design/postToChildren", {
  //     func: "page/initGoogleMap",
  //     payload: gmap,
  //   }, { root: true })
  // },
  initSiteMetadata({ commit }, { assets, props }) {
    commit('design/metadata/SET_METADATA_SITE', { assets, props }, { root: true })
  },
  initSitePage({ commit }, { assets, props }) {
    commit('design/metadata/SET_METADATA_PAGE', { assets, props }, { root: true })
  },
  initLanguage({ commit }, { language }) {
    commit('design/metadata/SET_ACTIVE_LANGUAGE', { language }, { root: true })
  },
  initLimit({ commit }, { limit }) {
    commit('SET_LIMIT', { limit });
  },
  setPage({ commit, dispatch, rootState }, { metaDataID, pageID, pageName, elementID = '' }) {
    dispatch('design/component/setActiveElementfromURL', {}, { root: true })
    if (rootState.design.snapshot.metadataObserver) {
      jsonpatch.unobserve(rootState.design.metadata, rootState.design.snapshot.metadataObserver)
    }
    commit('design/metadata/SET_ACTIVE_PAGE', { metaDataID, pageID, pageName, elementID }, { root: true })
    commit('SET_PAGE_NAME', { pageName })
    commit("design/component/SET_NEW_HASH", {}, { root: true });
    commit('design/snapshot/RESET_LOGS', {}, { root: true })
    rootState.design.snapshot.metadataObserver = jsonpatch.observe(rootState.design.metadata);
    dispatch('design/original/setOriginalObserver', JSON.parse(JSON.stringify(rootState.design.snapshot.metadataObserver)), { root: true })
    if(elementID == 'example') commit('SET_IS_EXAMPLE_PAGE', true )
    else commit('SET_IS_EXAMPLE_PAGE', false)
    dispatch('design/snapshot/mergelogs', {}, { root: true })
  },
  setPageName({ commit }, { pageName }) {
    commit('SET_PAGE_NAME', { pageName })
  },
  setPages: ({ commit }, { pages }) => {
    commit('SET_PAGES', { pages: pages })
  },
  setIsExamplePage({ commit }, isExamplePage) {
    commit('SET_IS_EXAMPLE_PAGE', isExamplePage)
  },
  initStatVisitorCount({ commit, dispatch }, { statVisitorCount } ) {
    commit('design/siteData/SET_STAT_VISITOR_COUNT', { statVisitorCount }, { root: true })
    dispatch("design/postToChildren", {
      func: "page/initStatVisitorCount",
      payload: { statVisitorCount },
    }, { root: true });
  },
}
const mutations = {
  SET_SITE_SERVICES(state, { services }) {
    state.services = services
  },
  SET_LANGUAGES(state, { languages }) {
    state.screen.languages = languages
  },
  SET_DOMAIN(state, { domain }) {
    state.screen.domain = domain
  },
  SET_PRODUCT(state, { product }) {
    state.screen.product = product
  },
  SET_BLOG(state, { blog }) {
    state.screen.blog = blog
  },
  SET_POST(state, { post }) {
    state.screen.post = post
  },
  SET_ALBUM(state, { album }) {
    state.screen.album = album
  },
  SET_ALBUM_CATEGORY(state, { albumCategory }) {
    state.screen.albumCategory = albumCategory
  },
  SET_EVENT_CALENDAR(state, { eventCalendar }) {
    state.screen.eventCalendar = eventCalendar
  },
  setPublishStatus(state, { publishStatus }) {
    state.publishStatus = publishStatus
  },
  SET_PAGES(state, { pages }) {
    state.pages = pages;
  },
  SET_PAGE_NAME(state, { pageName }) {
    state.pageName = pageName;
  },
  SET_IS_EXAMPLE_PAGE(state, isExamplePage) {
    state.isExamplePage = isExamplePage;
  },
  SET_CURRENCY_CONFIG(state, currencies) {
    state.config.currencies = currencies;
  },
  SET_CURRENCY_MAIN(state, currency) {
    state.currencyMain = currency
  },
  SET_CURRENCY_USE(state, currency) {
    state.currencyUse = currency
  },
  SET_CURRENCY_DISPLAY(state, currencyDisplay) {
    state.currencyDisplay = currencyDisplay
  },
  SET_CURRENCIES_CONVERTER(state, currenciesConverter) {
    state.currenciesConverter = currenciesConverter
  },
  SET_MULTIPLIER(state, multiplier ) {
    state.multiplier = multiplier
  },
  SET_LIMIT(state, { limit }) {
    state.limit = limit;
  },
  SET_PRODUCT_REVIEW_CONFIG(state, { productReviewConfig }) {
    state.productReviewConfig = productReviewConfig;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};